import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";

export const OverViewQuotation: React.FC<any> = React.memo((props) => {
  const isMobile = IsSmallScreen();
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getQuotationPermission;
  const navigate = useNavigate();
  const params = useParams();
  const [quotationData, setQuotationData] = useState<any>([])
  const id = params?.id;
  const [resetLoad, setResetLoad] = useState(false)
  useEffect(() => {
    const getQuotations = async () => {
      try {
        setResetLoad(false)
        const response: any = await callAPI(`quotations/lead/${id}`, Method.GET, null, null);

        setQuotationData(response?.data || []);

      }
      catch (e) {

      }
    }
    getQuotations();
  }, [resetLoad])
  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "customerName",
      tooltip: true,
      type: 'default'
    },
    {
      header: "No",
      fieldName: "quotationNumber",
      tooltip: true,
      type: 'default',
      isHide: isMobile
    },
    {
      header: "Expiry",
      fieldName: "validTill",
      tooltip: true,
      isHide: isMobile,
      type: 'date'
    },
    {
      header: "Total",
      fieldName: "grandTotal",
      type: 'default',
      isHide: isMobile
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined, "Convert to Order", "Print"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),

    },
  ];
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`quatation/${row?.id}`)
    }
    else if (action === "Print") {
      navigate(`/quatation/print/${row?.id}`);
    }
    else if (action === 'Convert to Order') {
      navigate(`order/convert-order/${row?.id}`);

    }
  }
  const handleQuotationAddClick = () => {
    navigate(`quatation`)
  }
  return (
    <Grid>
      <Grid container spacing={2} sx={{ marginTop: 2 }}>
        {view ? <Grid item xs={12}>
          <WSDataGrid
            id="quotationGrid"
            columns={columns}
            title="Quotations"
            data={quotationData}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
            addButton={add ? { label: "New", color: "secondary" } : undefined}
            onAddButtonClick={handleQuotationAddClick}
          />
        </Grid>
          : <PermissionDenied />
        }
      </Grid>
    </Grid>
  );
});
